"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientLogger = void 0;
const config_1 = __importDefault(require("next/config"));
class ClientLogger {
    constructor(_logGroupName) {
        const config = (0, config_1.default)();
        if (config) {
            const { publicRuntimeConfig } = config;
            this.shouldLog =
                publicRuntimeConfig && publicRuntimeConfig.envStage && publicRuntimeConfig.envStage.toLowerCase() !== 'prod';
        }
        if (this.shouldLog) {
            this.debug = console.debug;
            this.error = console.error;
            this.info = console.info;
            this.warn = console.warn;
        }
    }
    debug(..._message) {
    }
    error(..._message) {
    }
    info(..._message) {
    }
    warn(..._message) {
    }
}
exports.ClientLogger = ClientLogger;
